import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { selectHasPinnedVariables, selectNonPinnedVariablesWithInputControl } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { selectHasMultiplePrefabs } from '../../_redux-prefabs';
import { selectContentFirst } from '../../_redux-scene';
import { GiftWindowSteps, selectComponentForStep, useButtonText, useSteps } from '../shared/giftWindowSteps';
import { ContentFirstDesignWindowMobile } from './ContentFirstDesignWindowMobile';

const _GiftWindowCompositionMobile = ({ onClose, steps, contentFirst }: Props) => {

    const { step, next, previous } = useSteps(steps);

    const previousButtonText = useButtonText(steps[step - 1], 'previous', 'short');
    const nextButtonText = useButtonText(steps[step + 1], 'next', 'short');

    if (contentFirst) {
        return (
            <ContentFirstDesignWindowMobile onClose={onClose} />
        );
    }

    const CurrentStep = selectComponentForStep(steps[step]);

    return (
        <CurrentStep
            next={next} nextButtonText={nextButtonText}
            previous={previous} previousButtonText={previousButtonText}
            onClose={onClose} />
    );
};

type Props = {
    onClose: () => void;
    steps: GiftWindowSteps[];
    contentFirst: boolean;
};

const mapStateToProps = (state: GiftPdpState) => ({
    steps: selectSteps(state),
    contentFirst: selectContentFirst(state)
});

export const GiftWindowCompositionMobile = connect(
    mapStateToProps
)(_GiftWindowCompositionMobile);

const selectNonPinnedVariableStep = createSelector([
    selectNonPinnedVariablesWithInputControl
], (filteredVariables) => {
    if (filteredVariables.length === 1) {
        return 'single-non-pinned-variable';
    } else if (filteredVariables.length > 1) {
        return 'non-pinned-variables';
    }
});

const selectSteps = createSelector([
    selectHasPinnedVariables,
    selectHasMultiplePrefabs,
    selectNonPinnedVariableStep,
    (state: GiftPdpState) => state.scene.options.combineDesignAndPersonalization
], (hasPinnedVariables, hasPrefabs, nonPinnedVariablesStep, combineSteps) => {

    if (combineSteps && hasPrefabs && nonPinnedVariablesStep) {
        return [
            hasPinnedVariables && 'pinned-variables',
            nonPinnedVariablesStep,
            'overview'
        ].filter(Boolean) as GiftWindowSteps[];
    }

    return [
        hasPinnedVariables && 'pinned-variables',
        hasPrefabs && 'prefabs',
        nonPinnedVariablesStep,
        'overview'
    ].filter(Boolean) as GiftWindowSteps[];
});